export default __webpack_public_path__ + "static/media/faq.2f38f8db.svg";